import React from 'react'
import style from './HandError.module.scss'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import { useComponentLocale } from '../../hooks/useComponentLocale'
import { useDispatch } from 'react-redux'
import { handConstants } from '../../Redux/_reducers'
import {
	FieldTimeOutlined,
	FileExclamationOutlined,
	FileSyncOutlined,
	FileUnknownOutlined,
	FireOutlined,
} from '@ant-design/icons'

function HandError(props) {
	const getLocale = useComponentLocale()
	const parsedFailLocale = getLocale({ component: 'hand_result_error', section: 'title1' })
	const solvedFailLocale = getLocale({ component: 'hand_result_error', section: 'title2' })
	const instaLimitLocale = getLocale({ component: 'hand_result_error', section: 'title3' })
	const subExpiredLocale = getLocale({ component: 'hand_result_error', section: 'title4' })
	const notCalculatedLocale = getLocale({ component: 'hand_result_error', section: 'title5' })
	const reasonsLocale = getLocale({ component: 'hand_result_error', section: 'reason1' })
	const solutionsLocale = getLocale({ component: 'hand_result_error', section: 'reason2' })
	const checkSubLocale = getLocale({ component: 'hand_result_error', section: 'reason3' })
	const calcHandLocale = getLocale({ component: 'hand_result_error', section: 'reason4' })
	const contactTeamLocale = getLocale({ component: 'hand_result_error', section: 'advice1' })
	const tryAgainLocale = getLocale({ component: 'hand_result_error', section: 'advice2' })
	const incorrectHHLocale = getLocale({ component: 'hand_result_error', section: 'incorrect_hh' })
	const roomNotSupLocale = getLocale({ component: 'hand_result_error', section: 'room_not_sup' })
	const localSettingsLocale = getLocale({ component: 'hand_result_error', section: 'locale_settings' })
	const stackOutRangeLocale = getLocale({ component: 'hand_result_error', section: 'stack_out_range' })
	const gameNotSupLocale = getLocale({ component: 'hand_result_error', section: 'game_not_sup' })
	const noSolutionsLocale = getLocale({ component: 'hand_result_error', section: 'no_solution' })
	const limitLocale = getLocale({ component: 'hand_result_error', section: 'limit' })
	const extraLimitLocale = getLocale({ component: 'hand_result_error', section: 'extra_limit' })
	const btn1Locale = getLocale({ component: 'hand_result_error', section: 'btn1' })
	const btn2Locale = getLocale({ component: 'hand_result_error', section: 'btn2' })
	const purchaseSub1Locale = getLocale({ component: 'hand_result_error', section: 'purchase_sub1' })
	const purchaseLink1Locale = getLocale({ component: 'hand_result_error', section: 'purchase_sub_link1' })
	const purchaseSub2Locale = getLocale({ component: 'hand_result_error', section: 'purchase_sub2' })
	const purchaseLink2Locale = getLocale({ component: 'hand_result_error', section: 'purchase_sub_link2' })
	const uploadRunLocale = getLocale({ component: 'hand_result_error', section: 'upload_run' })
	const checkLimitLocale = getLocale({ component: 'hand_result_error', section: 'check_limit' })
	const checkSpotLocale = getLocale({ component: 'hand_result_error', section: 'check_spot' })
	const errorOccuredLocale = getLocale({ component: 'hand_result_error', section: 'error_occured' })

	const dispatch = useDispatch()

	const textErrorMessages = {
		0: {
			// errCode: 0,
			icon: <FileUnknownOutlined style={{ fontSize: '32px', color: '#faad14' }} />,
			title: parsedFailLocale,
			reason: reasonsLocale,
			hints: [{ text: incorrectHHLocale }, { text: roomNotSupLocale }, { text: localSettingsLocale }],
			advice: contactTeamLocale,
			key: '09e6241758add0786b0b93368024567c',
		},
		1: {
			// errCode: 1,
			icon: <FileExclamationOutlined style={{ fontSize: '32px', color: '#FF897A' }} />,
			title: solvedFailLocale,
			reason: reasonsLocale,
			hints: [{ text: stackOutRangeLocale }, { text: gameNotSupLocale }, { text: noSolutionsLocale }],
			advice: contactTeamLocale,
			key: 'b19114175dddde482a8a8064a4e59d0e',
		},
		10: {
			// errCode: 10,
			icon: <FileExclamationOutlined style={{ fontSize: '32px', color: '#FF897A' }} />,
			title: solvedFailLocale,
			reason: reasonsLocale,
			hints: [{ text: stackOutRangeLocale }, { text: gameNotSupLocale }, { text: noSolutionsLocale }],
			advice: contactTeamLocale,
			key: '01a0025fc6ccc9a33ee1baffca2c179f',
		},
		2: {
			// errCode: 2,
			icon: <FieldTimeOutlined style={{ fontSize: '32px', color: 'var(--primary_color)' }} />,
			title: instaLimitLocale,
			reason: solutionsLocale,
			hints: [
				{ text: limitLocale },
				{
					text: extraLimitLocale,
				},
			],
			button1: {
				link: '/library',
				text: btn1Locale,
			},
			button2: {
				link: '/settings/subscriptions',
				text: btn2Locale,
			},
			key: '2413d8b6a9a71c8786cfdd2d4d506ee8',
			advice: '',
		},
		3: {
			// errCode: 3,
			icon: <FireOutlined style={{ fontSize: '32px', color: '#FF897A' }} />,
			title: subExpiredLocale,
			reason: checkSubLocale,
			hints: [
				{
					text: purchaseSub1Locale,
					link: {
						word: purchaseLink1Locale,
						path: '/settings/subscriptions',
					},
				},
				{
					text: purchaseSub2Locale,
					link: {
						word: purchaseLink2Locale,
						path: '/library',
					},
				},
			],

			advice: tryAgainLocale,
			key: '68e2ae65744dc4fc61ab97ef46cce28d',
		},
		4: {
			// errCode: 4,
			icon: <FileSyncOutlined style={{ fontSize: '32px', color: 'var(--primary_color)' }} />,
			title: notCalculatedLocale,
			reason: calcHandLocale,
			hints: [{ text: uploadRunLocale }, { text: checkLimitLocale }, { text: checkSpotLocale }],
			advice: '',
			key: 'fef31a087e552cfcb5018461a381581f',
		},
	}

	const linkWrapper = (text, targetWord, path) => {
		text = text.toLowerCase()
		const indexSubstr = text.indexOf(targetWord)
		const leftPartText = text.slice(0, indexSubstr)
		const rightPartText = text.slice(indexSubstr + targetWord.length)

		return (
			<>
				{leftPartText}
				<Link to={path}>{targetWord.slice(0, 1).toUpperCase() + targetWord.slice(1)}</Link>
				{rightPartText}
			</>
		)
	}

	/* Error code, which we get, is in props.errorCode */
	const error = textErrorMessages[props.errorCode]
	// const error = textErrorMessages[4]

	const onBackButtonHandler = () => {
		dispatch({ type: handConstants.HAND_RAW_SUCCESS, rawHandResponse: null })
	}

	return (
		(error && (
			<div className={style.handErrorContainer}>
				<div className={style.handErrorSubstrate}>
					{/* <h2 className={style.handErrorContainerName}>Error</h2>*/}
					{error.icon}
					<p className={style.handErrorTitle}>{error.title}!</p>
					<p className={style.handErrorReason}>
						{error.reason}
						{':'}
						{/* <span className={style.highlightErrorHint}>{error.hints.length === 1 && error.hints[0].text}</span>*/}
					</p>
					{error.hints.length !== 1 && (
						<ul className={style.handErrorHints}>
							{error.hints.map((reason, index) => (
								<li style={{ whiteSpace: 'pre-wrap' }} key={error.key}>
									{props.errorCode !== 3
										? reason.text
										: linkWrapper(reason.text, reason.link.word, reason.link.path)}
									{index < error.hints.length - 1 ? ';' : '.'}
								</li>
							))}
						</ul>
					)}
					<p className={style.handErrorAdvice}>
						{error.advice + (error.advice ? '.' : '') ||
							(error.button1 && error.button2 && (
								<div className={style.handErrorAdviceControllers}>
									<a href={error.button1.link}>
										<Button type='primary' shape={'round'}>
											{error.button1.text}
										</Button>
									</a>
									<a style={{ marginLeft: 15 }} href={error.button2.link}>
										<Button shape={'round'}>{error.button2.text}</Button>
									</a>
								</div>
							))}
					</p>
					{/* <Button shape='round' onClick={onBackButtonHandler}>*/}
					{/*	Back*/}
					{/* </Button>*/}
				</div>
			</div>
		)) || <div>{errorOccuredLocale + '.'}</div>
	)
}

export default HandError
